module.exports = __webpack_public_path__ + "static/media/CTLA_9-383w.26a07275.webp";